import { createAction } from '@reduxjs/toolkit';
import { GET_DICTIONARIES_COMPETENCE_KINDS } from '../actionConstants';

export const getAllCompetenceKinds = createAction(
  GET_DICTIONARIES_COMPETENCE_KINDS
);
